import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { SAKA } from '@store/models';

@Component({
    selector: 'app-sa-ka-ui',
    templateUrl: './sa-ka.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SAKAComponent {

    @Input() sakas: SAKA[];
    @Output() caseClick = new EventEmitter<SAKA>();
    @Output() dismiss = new EventEmitter();

    onCaseClick(sag: SAKA) {
        this.caseClick.emit(sag);
    }

    onDismiss() {
        this.dismiss.emit();
    }

}
